import React, { useState } from 'react';
import './EASI.css';

const EASI = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    tipoReporte: '',
    descripcion: '',
    urls: '',
    fechaIncidente: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí iría la lógica para enviar el reporte
    alert('📨 Reporte enviado. Te contactaremos en 24-48 horas.');
    setFormData({
      nombre: '',
      email: '',
      tipoReporte: '',
      descripcion: '',
      urls: '',
      fechaIncidente: ''
    });
  };

  return (
    <div className="seguridad-container">
      {/* Header */}
      <header className="seguridad-header">
        <h1>🛡️ Estándares de Seguridad - Zodvia</h1>
        <p className="subtitle">Comprometidos con la protección y bienestar de nuestra comunidad</p>
      </header>

      {/* Introducción */}
      <section className="intro-section">
        <div className="card">
          <h2>🌟 Nuestro Compiso</h2>
          <p>
            En <strong>Zodvia</strong>, la seguridad de nuestros usuarios, especialmente de los más vulnerables, 
            es nuestra máxima prioridad. Implementamos medidas rigurosas para crear un espacio seguro y confiable 
            para tu crecimiento espiritual.
          </p>
        </div>
      </section>

      {/* Políticas de Seguridad */}
      <section className="politicas-section">
        <h2>📋 Políticas de Protección</h2>
        
        <div className="politicas-grid">
          <div className="politica-card">
            <div className="emoji">👶</div>
            <h3>Protección Infantil</h3>
            <ul>
              <li>Edad mínima: <strong>13 años</strong></li>
              <li>Contenido apropiado para todas las edades</li>
              <li>Cero tolerancia a contenido inapropiado</li>
            </ul>
          </div>

          <div className="politica-card">
            <div className="emoji">🔒</div>
            <h3>Privacidad y Datos</h3>
            <ul>
              <li>Tus lecturas son <strong>100% privadas</strong></li>
              <li>Datos encriptados en tu dispositivo</li>
              <li>Sin compartir información personal</li>
            </ul>
          </div>

          <div className="politica-card">
            <div className="emoji">🚫</div>
            <h3>Contenido Prohibido</h3>
            <ul>
              <li>Material sexual o explícito</li>
              <li>Acoso o bullying</li>
              <li>Spam o contenido comercial</li>
              <li>Información personal identificable</li>
            </ul>
          </div>

          <div className="politica-card">
            <div className="emoji">🛡️</div>
            <h3>Medidas Técnicas</h3>
            <ul>
              <li>Moderación proactiva de contenido</li>
              <li>Revisión automática de textos</li>
              <li>Sistema de reportes en tiempo real</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Formulario de Reporte */}
      <section className="reporte-section">
        <div className="card">
          <h2>📢 Reportar un Problema</h2>
          <p>
            Si encuentras contenido inapropiado o tienes preocupaciones sobre seguridad, 
            repórtalo inmediatamente usando este formulario.
          </p>

          <form onSubmit={handleSubmit} className="reporte-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="nombre">👤 Nombre completo *</label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">📧 Email de contacto *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="tipoReporte">🚨 Tipo de reporte *</label>
              <select
                id="tipoReporte"
                name="tipoReporte"
                value={formData.tipoReporte}
                onChange={handleChange}
                required
              >
                <option value="">Selecciona el tipo de problema</option>
                <option value="contenido">Contenido inapropiado</option>
                <option value="acoso">Acoso o bullying</option>
                <option value="menor">Problema con menor de edad</option>
                <option value="tecnico">Problema técnico</option>
                <option value="otro">Otro</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="fechaIncidente">📅 Fecha del incidente (aproximada)</label>
              <input
                type="date"
                id="fechaIncidente"
                name="fechaIncidente"
                value={formData.fechaIncidente}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="urls">🔗 URLs relacionadas (si aplica)</label>
              <input
                type="text"
                id="urls"
                name="urls"
                value={formData.urls}
                onChange={handleChange}
                placeholder="https://..."
              />
            </div>

            <div className="form-group">
              <label htmlFor="descripcion">📝 Descripción detallada *</label>
              <textarea
                id="descripcion"
                name="descripcion"
                value={formData.descripcion}
                onChange={handleChange}
                rows="5"
                placeholder="Describe el problema con todos los detalles posibles..."
                required
              ></textarea>
            </div>

            <button type="submit" className="submit-btn">
              🚀 Enviar Reporte
            </button>
          </form>
        </div>
      </section>

      {/* Información de Contacto */}
      <section className="contacto-section">
        <div className="card">
          <h2>📞 Contacto de Seguridad</h2>
          <div className="contacto-info">
            <div className="contacto-item">
              <span className="emoji">📧</span>
              <div>
                <strong>Email principal:</strong>
                <p>zodvia2025@gmail.com</p>
              </div>
            </div>
            <div className="contacto-item">
              <span className="emoji">⏰</span>
              <div>
                <strong>Tiempo de respuesta:</strong>
                <p>24-48 horas para reportes urgentes</p>
              </div>
            </div>
            <div className="contacto-item">
              <span className="emoji">🌐</span>
              <div>
                <strong>Respaldos:</strong>
                <p>Todos los reportes se archivan y siguen internamente</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="seguridad-footer">
        <p>© {new Date().getFullYear()} Zodvia - Todos los derechos reservados</p>
        <p>Última actualización: {new Date().toLocaleDateString()}</p>
      </footer>
    </div>
  );
};

export default EASI;